// extracted by mini-css-extract-plugin
module.exports = {"Copyright":"vOJQrjb5","icp":"Q_Rh0MhM","businessLicense":"__0ejfi80W","changArea":"__15sHdU5S"};